import React from "react";

const ThemeContext = React.createContext({});
ThemeContext.displayName = "ThemeContext";

export const ThemeProvider = ThemeContext.Provider;
export default ThemeContext;
